import React, { useContext } from 'react';
import { ProductTransaction, ProductTransactionType } from '../../../../../../../../types/productTransaction';
import { Grid } from '@mui/material';
import { ProductMasterData } from '../../../../../../../../types/product_master_data/productMasterData';
import { Container } from '../../../../../../../../types/container';
import { DropdownSearchSelect } from '../../../../../../../components/Dropdown';
import { StockLocationContext } from '../../../../../../../../context/StockLocationContext';
import { StockLocationRole } from '../../../../../../../../types/stock_location_role_assignment';
import { CompanyContext } from '../../../../../../../../context/CompanyContext';
import { StockLocationRoleAssignmentContext } from '../../../../../../../../context/StockLocationRoleAssignmentContext';
import { TranslationKey } from '../../../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../../../types/translation/Translator';

interface ProductTransactionSourceStockLocationProps {
  transaction: ProductTransaction;
  setTransaction: React.Dispatch<React.SetStateAction<ProductTransaction>>;

  productMasterData?: ProductMasterData;
  container?: Container;

  disabled?: boolean;
}

export default function ProductTransactionSourceStockLocation({
  transaction,
  setTransaction,
  productMasterData: pmd,
  disabled = false,
}: ProductTransactionSourceStockLocationProps) {
  if (transaction.type === ProductTransactionType.inbound || transaction.parentId) return null;

  const { currentCompany } = useContext(CompanyContext);
  const { stockLocations } = useContext(StockLocationContext);
  const { hasStockLocationRole } = useContext(StockLocationRoleAssignmentContext);

  const allowedStockLocations = [...stockLocations.values()].filter(
    item =>
      item.companyId === currentCompany.id &&
      hasStockLocationRole(currentCompany.id, item.id, StockLocationRole.STOCK_LOCATION_SUPERVISOR),
  );

  return (
    <Grid item xs={6}>
      <DropdownSearchSelect
        mandatory
        disabled={disabled}
        items={allowedStockLocations}
        value={stockLocations.get(transaction.product.fromStockLocationId || '')}
        textBuilder={item => item?.name || ''}
        label={t(TranslationKey.sourceStockLocation).singular.label}
        placeholder={t(TranslationKey.sourceStockLocation).singular.label}
        onSelect={item => {
          setTransaction(transaction => transaction.withFromStockLocationId(item?.id));
        }}
      />
    </Grid>
  );
}
